















































































import { Component } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "@/lib/ajax";
class NewcomerConfig {
  enable: boolean = false;
  title: string = "新人券";
  amount: number = 0;
  expiration: number = 30;
}
class CourtCouponConfig {
  usage: number = 0;
  title: string = "球场券";
  amount: number = 0;
  expiration: number = 30;
}

@Component({
  components: {},
})
export default class SiteConfig extends AbpBase {
  newcomerConfig: NewcomerConfig = new NewcomerConfig();
  courtCouponConfig: CourtCouponConfig = new CourtCouponConfig();
  spinShow: boolean = false;
  usageList: Array<any> = [
    {
      value: 0,
      label: "每订单使用一张",
    },
    {
      value: 1,
      label: "每人使用一张",
    },
  ];
  mounted() {
    this.getSiteConfigs();
    this.getCourtCouponConfig();
  }
  async getCourtCouponConfig() {
    let rep = await Ajax.get("/api/services/app/Coupon/GetCourtCouponConfig");
    Util.extend(true, this.courtCouponConfig, rep.data.result);
  }
  async getSiteConfigs() {
    let rep = await Ajax.get("/api/services/app/Coupon/GetNewcomerConfig");
    Util.extend(true, this.newcomerConfig, rep.data.result);
  }
  async saveSiteConfig() {
    (this.$refs.configForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.spinShow = true;
        await Ajax.post(
          "/api/services/app/Coupon/SetNewcomerConfig",
          this.newcomerConfig
        );
        this.spinShow = false;
        this.$Modal.success({
          title: "提示信息",
          content: "保存新人券设置成功！",
        });
      }
    });
  }
  async saveCourtSiteConfig() {
    (this.$refs.courtConfigForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.spinShow = true;
        await Ajax.post(
          "/api/services/app/Coupon/SetCourtCouponConfig",
          this.courtCouponConfig
        );
        this.spinShow = false;
        this.$Modal.success({
          title: "提示信息",
          content: "保存球场券设置成功！",
        });
      }
    });
  }
  validateAmount(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入优惠券金额"));
    } else {
      callback();
    }
  }
  validateExpiration(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入优惠券过期天数"));
    } else {
      callback();
    }
  }
  validateUsage(rule, value, callback){
    if(value==0 || value==1){
      callback();
    }else{
      callback(new Error("请输入优惠券使用方式"));
    }
  }
  configRule = {
    title: [
      {
        required: true,
        message: "请输入优惠券类型",
        trigger: "blur",
      },
    ],
    amount: [
      {
        required: true,
        message: "请输入优惠券金额",
        trigger: "blur",
        validator: this.validateAmount,
      },
    ],
  
    expiration: [
      {
        required: true,
        message: "请输入优惠券过期天数",
        trigger: "blur",
        validator: this.validateExpiration,
      },
    ],
  };
  courtConfigRule = {
    title: [
      {
        required: true,
        message: "请输入优惠券类型",
        trigger: "blur",
      },
    ],
    amount: [
      {
        required: true,
        message: "请输入优惠券金额",
        trigger: "blur",
        validator: this.validateAmount,
      },
    ],
      usage:[{
      required: true,
        message: "请选择使用方式",
        trigger: "blur change",
        validator: this.validateUsage,
    }],
    expiration: [
      {
        required: true,
        message: "请输入优惠券过期天数",
        trigger: "blur",
        validator: this.validateExpiration,
      },
    ],
  };
}
